import React from 'react'
import './NewBrands.css'

function NewBrands() {
    const listOfnewArrival = ['https://firebasestorage.googleapis.com/v0/b/blinkkopticals-6c609.appspot.com/o/flings.png?alt=media&token=3198d3c9-eabe-4002-a828-214854fc4124', 'https://firebasestorage.googleapis.com/v0/b/blinkkopticals-6c609.appspot.com/o/scott.png?alt=media&token=2ca1e90f-2931-43ab-8306-b23b14fef4e4','https://firebasestorage.googleapis.com/v0/b/blinkkopticals-6c609.appspot.com/o/flings.png?alt=media&token=3198d3c9-eabe-4002-a828-214854fc4124', 'https://firebasestorage.googleapis.com/v0/b/blinkkopticals-6c609.appspot.com/o/scott.png?alt=media&token=2ca1e90f-2931-43ab-8306-b23b14fef4e4']
  return (
    <div className='newarrivals new_brands'>
            <div className='new_arrivals_heading'>
                <p className='new_arrival_text'>Eyeglasses Brands</p>
            </div>
            <div className='new_arrival_list'>
                {listOfnewArrival.map((item, index) => {
                    return (<img className='new_arrival_img' src={item} alt={item} key={index} />)
                }
                )}
            </div>
        </div>
  )
}

export default NewBrands